import getOrderLineDosFrom1 from 'utils/print/getOrderLineDosFrom1';
import getOrderLineDosFrom2 from 'utils/print/getOrderLineDosFrom2';
import getOrderLineDosFrom3 from 'utils/print/getOrderLineDosFrom3';
import getOrderLineDosTo1 from 'utils/print/getOrderLineDosTo1';
import getOrderLineDosTo2 from 'utils/print/getOrderLineDosTo2';
import getOrderLineDosTo3 from 'utils/print/getOrderLineDosTo3';

const getOrderLineDosFrom = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const orderLineDosFrom1 = getOrderLineDosFrom1(otherProps);
  const orderLineDosFrom2 = getOrderLineDosFrom2(otherProps);
  const orderLineDosFrom3 = getOrderLineDosFrom3(otherProps);
  const orderLineDosTo1 = getOrderLineDosTo1(otherProps);
  const orderLineDosTo2 = getOrderLineDosTo2(otherProps);
  const orderLineDosTo3 = getOrderLineDosTo3(otherProps);
  if (orderLineDosFrom1 && orderLineDosFrom2 && orderLineDosFrom3
    && orderLineDosTo1 && orderLineDosTo2 && orderLineDosTo3) {
    return `${orderLineDosFrom1}/${orderLineDosFrom2}/${orderLineDosFrom3}-${orderLineDosTo1}/${orderLineDosTo2}/${orderLineDosTo3}`;
  }

  return null;
};

export default getOrderLineDosFrom;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosFromTo.js